<template>
  <mds-page-shell
    :logo="`${publicPath}images/logo.svg`"
    :logo-responsive="`${publicPath}images/logo.svg`"
    logo-alt="Morningstar Radar"
    sticky
    class="radar"
  >
    <template v-slot:mds-page-shell-masthead-right>
      <fade-transition>
        <mds-button
          v-if="signedIn"
          variation="flat"
          @click="handleSignOut"
        >
          Sign Out
        </mds-button>
      </fade-transition>
    </template>
    <template v-slot:mds-page-shell-horizontal-nav>
      <mds-tabs
        v-if="showNavigation"
        :content="topLevelTabs"
        alignment="center"
        size="large"
        variation="site-navigation"
      />
    </template>
    <mds-notification-container
      v-show="notifications.length"
      masthead-padding="below-masthead"
    >
      <mds-notification
        v-for="notification in notifications"
        :key="notification.id"
        v-bind="notification"
        @mds-notification-dismissed="removeNotification(notification.id)"
      >
        {{ notification.text }}
      </mds-notification>
    </mds-notification-container>

    <div class="main-container">
      <fade-transition duration="1-and-a-half-x">
        <router-view />
      </fade-transition>
    </div>

    <footer>
      <p>&copy; {{ currentYear }} Morningstar. All Rights Reserved.</p>
    </footer>
  </mds-page-shell>
</template>

<script>
import FadeTransition from './components/Transitions/FadeTransition'
import { MdsButton } from '@mds/button'
import MdsPageShell from '@mds/page-shell'
import MdsTabs from '@mds/tabs'
import { MdsNotificationContainer, MdsNotification } from '@mds/notification'
import { GET_USER } from './graqhql/queries'
import { SIGN_OUT } from './graqhql/mutations'

// TODO: Figure out route undefined issue

export default {
  components: {
    FadeTransition,
    MdsButton,
    MdsPageShell,
    MdsTabs,
    MdsNotificationContainer,
    MdsNotification,
  },
  apollo: {
    user: GET_USER,
  },
  data () {
    return {
      publicPath: process.env.BASE_URL,
      user: null,
      notifications: [],
    }
  },
  computed: {
    signedIn () {
      return !!this.user
    },
    currentlySelectedTopLevelRoute () {
      return this.$route?.matched[0]
    },
    topLevelRoutes () {
      return this.$router.options.routes.filter(route => route.meta && route.meta.main)
    },
    topLevelTabs () {
      return this.topLevelRoutes.map(route => ({
        text: route.meta.title,
        href: this.$router.resolve({ name: route.name }).href,
        active: route.name === this.currentlySelectedTopLevelRoute?.name,
      }))
    },
    currentYear () {
      return new Date().getFullYear()
    },
    showNavigation () {
      // May need to revisit this logic
      return this.signedIn && !this.$route.meta.hideNavigation
    },
  },
  mounted () {
    this.$notifications.subscribe(this.addNotification)
  },
  methods: {
    addNotification (notification) {
      this.notifications.push(notification)
    },
    removeNotification (notificationId) {
      this.notifications = this.notifications.filter(notification => notification.id !== notificationId)
    },
    async handleSignOut () {
      await this.$apollo.mutate({ mutation: SIGN_OUT })
      await this.$apollo.getClient().clearStore()
      await this.$apollo.queries.user.refetch()
      this.$router.push({ name: 'sign-in' })
    },
  },
}
</script>

<style lang="scss">
:root {
  --color--brand: #1E53AC;
  --color--background: var(--color--brand);
  --space--10-x: 80px;
  --shadow--panel: 0 32px 64px -40px rgba(0, 0, 0, .5);

  --grid--main-layout-max-width: 1308px;
  --grid--main-layout-gap: 16px;
  --grid--main-layout-padded-column: calc(50vw - (var(--grid--main-layout-max-width) / 2) - var(--grid--main-layout-gap));
  --grid--main-layout-columns: var(--grid--main-layout-padded-column) 1fr var(--grid--main-layout-padded-column);
}

body {
  @include mds-body-text-m();
  color: $mds-text-color-primary;
  background-color: var(--color--background);
}

// TODO: come back to responsive styles
.main-container {
  display: grid;
  align-items: start;
  grid-template-columns: var(--grid--main-layout-columns);
  gap: 0 var(--grid--main-layout-gap);
  padding: $mds-space-8-x 0 var(--space--10-x);
  min-height: 80vh;

  > * {
    grid-column: 2 / span 1;
  }
}

footer {
  @include mds-body-text-s();
  display: grid;
  grid-template-columns: var(--grid--main-layout-columns);
  gap: 0 var(--grid--main-layout-gap);
  padding: $mds-space-4-x 0 $mds-space-6-x;
  color: $mds-text-color-secondary;
  background-color: $mds-background-color-white;

  > p {
    grid-column: 2 / span 1;
  }
}
</style>

<style lang="scss" module>
:global(.radar) {
  .mds-page-shell__masthead-logo-wide,
  .mds-page-shell__masthead-logo {
    width: auto;
    height: 45px;
  }
}
</style>
